module.exports = __webpack_public_path__ + "img/Innen22.bef92900.jpg";